import PropTypes from 'prop-types';
import React from 'react';
import {AnyToDo} from '../../../typings/todo';

export class Currency extends React.Component<AnyToDo> {
  static propTypes = {
    currency: PropTypes.string.isRequired,
    children: PropTypes.node,
  };

  render() {
    const {currency, children} = this.props;
    return (
      <span className={currency} data-hook="currency">
        {children}
      </span>
    );
  }
}
